<div
  fxLayout="column"
  class="height-100">

  <!-- Toolbar -->
  <div>
    <mat-toolbar fxLayout="row">
      <!-- Close -->
      <span fxFlex fxLayoutAlign="start center">
        <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="close()" type="button">
          <mat-icon *ngIf="!media.isActive('lt-sm')" svgIcon="close"></mat-icon>
          <mat-icon *ngIf="media.isActive('lt-sm')" svgIcon="arrow-left"></mat-icon>
        </button>
      </span>

      <!-- Detail Title -->
      <span 
        fxLayout="row" 
        fxLayoutAlign="center center"
        [class.compact-header-text]="media.isActive('lt-sm')"
        fxFlex="noshrink">        
        {{ 'LABEL_DETAIL' | translate: {type: type} }}
      </span>    
      
      <!-- Edit -->
      <span fxFlex fxLayoutAlign="end center">
        <button 
          mat-icon-button 
          (click)="modify()" 
          [matTooltip]="'LABEL_EDIT' | translate"
          *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update)"
          >
          <mat-icon svgIcon="pencil"></mat-icon>
        </button>
      </span>
    </mat-toolbar>
  </div>

  <div class="height-100 width-100">
    <mat-tab-group dynamicHeight="false" class="mat-tab-group-md-width" [(selectedIndex)]="selectedTabIndex">
      <!-- Detail Data -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ 'LABEL_DETAILS' | translate}}</span>
        </ng-template>
        
        <mat-list>
          <mat-list-item 
            class="detail-list-height"
            *ngFor="let key of detailKeys1"
            (click)="(key == 'reference_filename') && detailData?.presigned_url && download()"
            [class.pointer]="key == 'reference_filename' && detailData?.presigned_url"
            >
            <h3 matLine class="list-data" fxLayoutAlign="start center">
              <mat-icon *ngIf="key == 'reference_filename' && detailData?.presigned_url" svgIcon="download-circle-outline" class="scale-9" color="primary"></mat-icon>
              <span class="word-wrap">
                <!-- {{ detailData[key] }} -->
                {{ (key == 'is_active' || key == 'terminal_is_registered') ? (helper.displayFields(detailData, key) | translate) : helper.displayFields(detailData, key, moduleCode, displayMode) }}
              </span>
            </h3>
            <p matLine class="list-label">
              {{ ('LABEL_' + key | uppercase) | translate }}
            </p>
          </mat-list-item>
        </mat-list>
      </mat-tab>

      <!-- SMS Responses -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ 'LABEL_CAMPAIGN_SMS_RESPONSES' | translate}}</span>
        </ng-template>
        
        <mat-list>
          <mat-list-item 
            class="detail-list-height"
            *ngFor="let key of detailKeys2; let i = index"
            [class.padding-bottom-2p]="displayFields(detailData?.campaign_sms_message[i], key).length > 70"
            >
            <h3 matLine class="list-data" fxLayoutAlign="start center">
              <span class="word-wrap">
                {{ displayFields(detailData?.campaign_sms_message[i], key) }}
              </span>
            </h3>
            <p matLine class="list-label">
              {{ ('LABEL_SMS_' + key | uppercase) | translate }}
            </p>
          </mat-list-item>
        </mat-list>
      </mat-tab>
    </mat-tab-group>
  </div>

</div>